export function controlCenterActivateServerModel(data) {
  return {
    UserId: data.userId,
    ControlCenterId: data.controlCenterId,
    PullOrders: data.pullOrders
  };
}
